import React from 'react';
import { motion } from 'framer-motion';
import LogoCarousel from './LogoCarousel';
import ApplyButton from './ApplyButton';
interface LogoSectionProps {
  scrollToCalendar?: () => void;
}
const LogoSection = ({
  scrollToCalendar
}: LogoSectionProps) => {
  return <section className="w-full bg-white py-6 sm:py-10 px-3 sm:px-4" data-id="element-176">
      <div className="max-w-7xl mx-auto" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7
      }} className="text-center" data-id="element-178">
          <h3 className="text-center text-lg sm:text-2xl md:text-3xl text-gray-900 mb-4 sm:mb-6 leading-relaxed px-1" data-id="element-179">
            Our team has been trusted by…
          </h3>
          <LogoCarousel data-id="element-180" />
          <div className="mt-8 sm:mt-10" data-id="element-181">
            {scrollToCalendar ? <div className="flex justify-center" data-id="element-182">
                <div className="relative" data-id="element-183">
                  <div className="button-border-light" data-id="element-184"></div>
                  <motion.button onClick={scrollToCalendar} whileHover={{
                scale: 1.05,
                boxShadow: '0px 8px 20px rgba(255, 223, 7, 0.3)'
              }} className="relative z-10 bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] text-black font-semibold py-3 sm:py-4 px-8 sm:px-12 rounded-md text-base sm:text-lg shadow-[0_4px_14px_rgba(255,223,7,0.25)] border border-[#ffd70077] transition-all duration-300" data-id="element-185">
                    Book My Strategy Call
                  </motion.button>
                </div>
              </div> : <ApplyButton data-id="element-186" />}
          </div>
        </motion.div>
      </div>
    </section>;
};
export default LogoSection;